var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptimizedCostIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2080",
    "data-name": "Group 2080",
    transform: "translate(-788 -1362)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(788 1362)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "money",
    transform: "translate(765.427 1372.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    "data-name": "Group 1220",
    transform: "translate(36.238 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1213",
    "data-name": "Group 1213",
    transform: "translate(17.156 25.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3442",
    "data-name": "Path 3442",
    d: "M223.217,273.96a1.872,1.872,0,0,0-.525-.382,6.34,6.34,0,0,0-1.331-.47v3.523a2.5,2.5,0,0,0,1.973-1.04h0a1.61,1.61,0,0,0,.146-1.1A1.106,1.106,0,0,0,223.217,273.96Z",
    transform: "translate(-221.36 -273.108)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    "data-name": "Group 1214",
    transform: "translate(19.125 27.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3443",
    "data-name": "Path 3443",
    d: "M242.6,299.907l0-.007h0Z",
    transform: "translate(-242.604 -299.9)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215",
    transform: "translate(13.457 19.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3444",
    "data-name": "Path 3444",
    d: "M181.679,212.98a1.322,1.322,0,0,0-.228.619,1.485,1.485,0,0,0,.076.685,1.1,1.1,0,0,0,.426.469,3.33,3.33,0,0,0,.634.327c.185.074.393.146.617.214v-3.188A2.433,2.433,0,0,0,181.679,212.98Z",
    transform: "translate(-181.441 -212.106)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    "data-name": "Group 1216",
    transform: "translate(19.129 27.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3445",
    "data-name": "Path 3445",
    d: "M242.662,299.619l-.015.026h0Z",
    transform: "translate(-242.647 -299.619)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    "data-name": "Group 1217",
    transform: "translate(19.162 27.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3446",
    "data-name": "Path 3446",
    d: "M243,299.246Z",
    transform: "translate(-243.004 -299.244)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    "data-name": "Group 1218",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3447",
    "data-name": "Path 3447",
    d: "M54.636,8.57c3-2.517,5-8.187,3.766-8.435-1.637-.33-5.192,1.116-6.91,1.371C49.055,1.8,46.4-1.137,44.911.5c-1.211,1.331.868,6.172,4.122,8.28-9.708,4.771-23.353,28.724.452,30.462C82.423,41.647,65.93,13.219,54.636,8.57Zm2.829,18.89a3.463,3.463,0,0,1-1.336,2.352,5.106,5.106,0,0,1-2.734.966v1.032a.969.969,0,1,1-1.937,0V30.682c-.167-.032-.333-.069-.5-.114a4.756,4.756,0,0,1-2.37-1.458,4.272,4.272,0,0,1-.73-1.207c-.045-.115-.086-.232-.121-.351a1.8,1.8,0,0,1-.076-.328.969.969,0,0,1,1.883-.4c.037.112.062.226.1.337a2.159,2.159,0,0,0,.149.318,2.47,2.47,0,0,0,.425.544,2.884,2.884,0,0,0,1.233.672V24.859a6.9,6.9,0,0,1-2.54-1.1,2.956,2.956,0,0,1-.858-1.03,3.225,3.225,0,0,1-.3-1.387,3.3,3.3,0,0,1,.29-1.4,3.424,3.424,0,0,1,.795-1.091,4.853,4.853,0,0,1,2.612-1.158V16.62a.969.969,0,1,1,1.938,0v1.065q.19.024.379.058A4.785,4.785,0,0,1,56.3,18.97a3.7,3.7,0,0,1,.774,1.113,3.55,3.55,0,0,1,.137.354,2.152,2.152,0,0,1,.091.345.969.969,0,0,1-1.863.49c-.041-.106-.061-.218-.1-.323a1.707,1.707,0,0,0-.158-.305,1.848,1.848,0,0,0-.458-.48,3.141,3.141,0,0,0-1.33-.52v3.668a12.3,12.3,0,0,1,1.655.491,3.869,3.869,0,0,1,2.019,1.581c-.069-.12-.135-.238,0,0s.071.124,0,.005A3.456,3.456,0,0,1,57.465,27.46Z",
    transform: "translate(-36.238 0)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1219",
    "data-name": "Group 1219",
    transform: "translate(19.101 27.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3448",
    "data-name": "Path 3448",
    d: "M242.351,300.169l-.014.026Z",
    transform: "translate(-242.337 -300.169)",
    fill: "#fafafa"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimizedCostIcon);
export default __webpack_public_path__ + "static/media/optimized-cost-icon.3914d250d3b3cf87068feb7747aa4952.svg";
export { ForwardRef as ReactComponent };